/*
  Barra fija de la ficha de producto (<sticky-add-to-cart>).

  - A la izquierda, el nombre de la variante elegida (las opciones separadas
    por " · "); se actualiza al cambiar de modelo o de diseno.
  - El boton repite el de la ficha: mismo texto, el precio de esa variante y,
    al pulsarlo, se pulsa el boton principal, o sea el mismo formulario y el
    mismo JS del tema. Asi siguen funcionando igual el carrito lateral, el
    cordon de regalo, las ofertas y el resto.
  - Mientras anade no cambia nada; cuando la tienda confirma, el boton pasa a
    "Anadido al carrito" 2,5 s y vuelve con un fundido. Si falla, vuelve ya.

  No toca ni la posicion, ni el tamano, ni el marco de la barra: eso lo fijan
  snippets/product-media.liquid (movil) y section-main-product.css.
*/
(() => {
  const PREFIJO = window.KT_PREFIX || '';
  const MS_AVISO = 2500;   // lo que dura el "Anadido al carrito"
  const MS_FUNDIDO = 200;  // tiene que ir con la transicion del CSS
  const MS_RESCATE = 12000; // por si el tema no llega ni a enviar el formulario

  const cuandoEsteElDOM = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  function montar(barra) {
    if (barra.dataset.corkStickyInit === '1') return;
    barra.dataset.corkStickyInit = '1';

    const ficha = document.getElementById(barra.dataset.id);
    if (!ficha) return;

    const boton = barra.querySelector('[data-cork-sticky-atc]');
    const texto = barra.querySelector('[data-cork-sticky-atc-text]');
    const precio = barra.querySelector('[data-cork-sticky-atc-price]');
    const nombre = barra.querySelector('[data-cork-sticky-name]');

    const botonFicha = ficha.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
    const textoFicha = botonFicha && botonFicha.querySelector('[data-js-product-add-to-cart-text]');
    const formulario = ficha.querySelector('product-form');
    const selector = ficha.querySelector('product-variants[data-main-product-variants]');
    const campoId = ficha.querySelector('form[action*="/cart/add"] input[name="id"]');

    let precios = {};
    const datos = barra.querySelector('[data-cork-sticky-prices]');
    if (datos) {
      try { precios = JSON.parse(datos.textContent); } catch (e) { precios = {}; }
    }

    if (!boton) return;
    if (!botonFicha) { boton.hidden = true; return; }

    // Color de fondo de la pagina, para el halo que tapa el hueco de las
    // esquinas redondeadas (por ahi se veia el texto que hay detras).
    const fondoDePagina = () => {
      const donde = [barra.parentElement, document.querySelector('.main-container'), document.body, document.documentElement];
      for (const el of donde) {
        if (!el) continue;
        const c = window.getComputedStyle(el).backgroundColor;
        if (c && c !== 'transparent' && c !== 'rgba(0, 0, 0, 0)') return c;
      }
      return '#000';
    };
    barra.style.setProperty('--cork-sticky-fondo', fondoDePagina());

    const textoAnadido = boton.dataset.corkStickyAdded || '';
    let avisando = false;     // ensenando "Anadido al carrito"
    let enCurso = false;      // esperando respuesta de la tienda
    let relojAviso = null;
    let relojRescate = null;

    const varianteActual = () => {
      if (selector && selector.currentVariant && selector.currentVariant.id) {
        return String(selector.currentVariant.id);
      }
      if (campoId && campoId.value) return String(campoId.value);
      return '';
    };

    const pintaBoton = () => {
      const dato = precios[varianteActual()];
      const bloqueado = botonFicha.classList.contains(PREFIJO + 'disabled') || (dato ? !dato.a : false);

      if (texto && textoFicha) texto.textContent = textoFicha.textContent.trim();
      // Si esta agotada o sin variante elegida, solo el texto del tema: poner
      // un precio al lado de "Agotado" no dice nada.
      if (precio) precio.innerHTML = dato && !bloqueado ? '&middot;&nbsp;' + dato.p : '';

      boton.disabled = bloqueado;
      boton.classList.toggle(PREFIJO + 'disabled', bloqueado);
    };

    // El nombre se refresca siempre; el boton, solo si no esta dando el aviso.
    const pintar = () => {
      const dato = precios[varianteActual()];
      if (nombre && dato && dato.n) nombre.textContent = dato.n;
      if (!avisando) pintaBoton();
    };

    const conFundido = (cambia) => {
      boton.classList.add('is-cambiando');
      window.setTimeout(() => {
        cambia();
        boton.classList.remove('is-cambiando');
      }, MS_FUNDIDO);
    };

    const avisaAnadido = () => {
      avisando = true;
      conFundido(() => {
        if (texto) texto.textContent = textoAnadido;
        if (precio) precio.innerHTML = '';
      });
      window.clearTimeout(relojAviso);
      relojAviso = window.setTimeout(() => {
        conFundido(() => { avisando = false; pintaBoton(); });
      }, MS_AVISO);
    };

    const suelta = () => {
      enCurso = false;
      window.clearTimeout(relojRescate);
    };

    boton.addEventListener('click', () => {
      if (enCurso) return;
      enCurso = true;
      window.clearTimeout(relojRescate);
      relojRescate = window.setTimeout(suelta, MS_RESCATE);
      botonFicha.click();
    });

    // El tema lanza 'add-to-cart' en el <product-form> cuando la tienda ya ha
    // respondido que si; el 'working' del boton de la ficha se quita despues,
    // tanto si ha ido bien como si no.
    if (formulario) {
      formulario.addEventListener('add-to-cart', () => {
        if (!enCurso) return;
        suelta();
        avisaAnadido();
      });
    }

    let trabajaba = botonFicha.classList.contains(PREFIJO + 'working');
    new MutationObserver(() => {
      const trabaja = botonFicha.classList.contains(PREFIJO + 'working');
      if (trabajaba && !trabaja && enCurso) { suelta(); pintaBoton(); }
      trabajaba = trabaja;
      pintar();
    }).observe(botonFicha, { attributes: true, attributeFilter: ['class'] });

    // El tema decide si se ve la barra mirando el boton de compra de la ficha.
    // En los accesorios ese boton esta oculto por CSS (lo sustituye .cpa-btn),
    // asi que su rectangulo es 0x0, el tema cree que esta a la vista y no saca
    // nunca la barra. Cuando pasa eso, se mira el boton que se ve de verdad y
    // se aplica la misma regla del tema. En las fundas no entra aqui.
    const seVe = (el) => !!el && !!el.offsetParent && el.getBoundingClientRect().height > 10;
    if (!seVe(botonFicha)) {
      const ancla = [...ficha.querySelectorAll('.cpa-btn, [data-js-product-add-to-cart]')].find(seVe)
        || ficha.querySelector('product-form');
      if (ancla) {
        const decide = () => {
          const r = ancla.getBoundingClientRect();
          const alto = window.innerHeight || document.documentElement.clientHeight;
          const ancho = window.innerWidth || document.documentElement.clientWidth;
          const aLaVista = r.top >= 0 && r.left >= 0 && (r.bottom - 80) <= alto && r.right <= ancho;
          const movil = window.innerWidth < 728;
          barra.classList.toggle(PREFIJO + 'visible', (!movil && r.top < 0) || (movil && !aLaVista));
        };
        window.addEventListener('scroll', decide, { passive: true });
        window.addEventListener('resize', decide);
        // si el tema vuelve a quitar la clase, se corrige
        new MutationObserver(decide).observe(barra, { attributes: true, attributeFilter: ['class'] });
        decide();
      }
    }

    if (textoFicha) {
      new MutationObserver(pintar).observe(textoFicha, { childList: true, characterData: true, subtree: true });
    }
    if (selector) {
      selector.addEventListener('VARIANT_CHANGE', () => window.requestAnimationFrame(pintar));
    }

    pintar();
  }

  cuandoEsteElDOM(() => {
    document.querySelectorAll('sticky-add-to-cart[data-cork-sticky]').forEach(montar);
  });
})();
